import gsap from "gsap";

/**
 * DropdownController class
 */
export default class DropdownController {
    constructor() {
        /**
         *
         * @type {{active: string, dropdowns: string, list: string, btn: string}}
         */
        this.defaults = {
            //elements
            dropdowns: ".js-dropdown",
            btn: ".js-dropdown-btn",
            list: ".js-dropdown-list",

            //CSS classes
            active: "is-opened",
            dropdownClass: "js-dropdown",
        };
    }

    //region methods
    /**
     * DropdownController class init method and init flag
     */
    init() {
        console.log("DropdownController init()");

        const dropdowns = document.querySelectorAll(this.defaults.dropdowns);

        if (dropdowns.length > 0) {
            dropdowns.forEach((dropdown) => {
                this.dropdownController(dropdown);
            });

            this.detectOutsideClick(dropdowns);
        }
    }

    /**
     *
     * @param dropdowns
     */
    detectOutsideClick(dropdowns) {
        let itemArray = [];
        dropdowns.forEach((dropdown) => {
            itemArray.push(dropdown);
        });

        document.addEventListener("click", (evt) => {
            let targetElement = evt.target;

            do {
                if (itemArray.includes(targetElement)) {
                    return;
                }
                // Go up the DOM
                targetElement = targetElement.parentNode;
            } while (targetElement);

            // This is a click outside.
            dropdowns.forEach((dropdown) => {
                if (dropdown.classList.contains(this.defaults.active)) {
                    const list = dropdown.querySelector(this.defaults.list);
                    dropdown.classList.remove(this.defaults.active);
                    this.close(list);
                }
            });
        });
    }

    /**
     *
     * @param dropdown
     */
    dropdownController(dropdown) {
        const list = dropdown.querySelector(this.defaults.list);
        const btn = dropdown.querySelector(this.defaults.btn);

        btn.addEventListener("click", () => {
            if (dropdown.classList.contains(this.defaults.active)) {
                dropdown.classList.remove(this.defaults.active);
                this.close(list);
                return;
            }
            dropdown.classList.add(this.defaults.active);
            this.open(list);
        });
    }

    /**
     *
     * @param list
     */
    open(list) {
        let height = 0;

        gsap.set(list, {
            height: "auto",
            onComplete: () => {
                height = list.offsetHeight;
                gsap.set(list, {
                    height: 0,
                    onComplete: () => {
                        gsap.to(list, {
                            height: height,
                            ease: "power3.out",
                            duration: 0.4,
                        });
                    },
                });
            },
        });
    }

    /**
     *
     * @param list
     */
    close(list) {
        gsap.to(list, {
            height: 0,
            ease: "power3.in",
            duration: 0.4,
        });
    }

    //endregion
}
